import fetch from './fetch'
import * as api from '../config/api'
import download from './download'

export const headerSuratMasuk = [
  { sortable: true, text: 'No. Urut', value: 'index_surat', align: 'center' },
  {
    text: 'TGL MASUK',
    sortable: false,
    value: 'tgl_masuk'
  },
  {
    text: 'KODE',
    sortable: false,
    value: 'index_surat_tu',
    width: 100
  },
  {
    text: 'INDEX',
    sortable: false,
    value: 'klasifikasi.jenis',
    width: 350
  },
  {
    text: 'TGL. SURAT',
    sortable: false,
    value: 'tgl_surat'
  },
  {
    text: 'NOMOR SURAT',
    sortable: false,
    value: 'no'
  },
  {
    text: 'PERIHAL',
    sortable: false,
    value: 'perihal',
    width: '200'
  },
  { text: 'PENGIRIM', sortable: false, value: 'pengirim', width: 200 },
  { text: 'TUJUAN', sortable: false, value: 'tujuan', width: 250 },
  { text: 'TEMBUSAN', sortable: false, value: 'tembusan', width: 250 },
  {
    text: '',
    sortable: false,
    value: 'note',
    width: 250
  },
  {
    sortable: false,
    value: 'actions',
    align: 'center'
  }
]

export const fetchSuratMasuk = async (
  params = {
    page: 1,
    q: '',
    month: null,
    year: null,
    per_page: 10,
    sort: 'dest'
  },
  isPimpinan = false
) => {
  try {
    const url = isPimpinan ? api.suratMasuk + '/pimpinan' : api.suratMasuk
    const response = await fetch.get(url, { params })
    let { data, ...pagination } = response.data
    data = data.map((dt, index) => {
      let { agenda, ...item } = dt
      return {
        ...item,
        order: index,
        tgl: agenda ? agenda.tgl : '',
        tgl_selesai: agenda ? agenda.tgl_selesai : '',
        waktu: agenda ? agenda.waktu : '',
        waktu_selesai: agenda ? agenda.waktu_selesai : '',
        tempat: agenda ? agenda.tempat : ''
      }
    })
    return Promise.resolve({ data, pagination })
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getArsipSuratMasuk = function(context, year) {
  return new Promise((resolve, reject) => {
    const params = {
      year: parseInt(year)
    }
    if (null === year || isNaN(year)) delete params['year']

    fetch
      .get(api.arsipSuratMasuk, { params })
      .then(response => {
        const data = response.data
        context.commit('SET_ARSIP_SURATMASUK', data)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const saveSuratMasuk = (data = {}) => {
  let formData = new FormData()

  const { lampiran, tujuan, tembusan, ...allData } = data

  for (const key in allData) {
    if (Object.hasOwnProperty.call(allData, key)) {
      const value = allData[key]
      if (value) {
        formData.append(key, value.toString())
      }
    }
  }

  tujuan.forEach((tj, index) => {
    formData.append(`tujuan[${index}]`, tj)
  })

  tembusan.forEach((tb, index) => {
    formData.append(`tembusan[${index}]`, tb)
  })

  if (lampiran && lampiran.length) {
    formData.append('lampiran', lampiran[0])
  }

  return new Promise(async (resolve, reject) => {
    try {
      let url = api.suratMasuk
      if (data.id) {
        formData.append('_method', 'PUT')
        url = api.suratMasuk + '/' + data.id
      }
      const response = await fetch.post(url, formData)
      resolve(response)
    } catch (error) {
      reject(error)
    }
  })
}

export const deleteSuratMasuk = async id =>
  await fetch.delete('surat-masuk/' + id)

export const deleteSuratKeluar = async id =>
  await fetch.delete('surat-keluar/' + id)

export const saveSuratKeluar = function(data) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log('SUBMIT SURAT KELUAR', data)
      let formData = new FormData()

      const { lampiran, ...form } = data

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          let value = form[key] || ''
          formData.append(key, value.toString())
        }
      }

      if (lampiran && typeof lampiran !== 'string' && lampiran.length) {
        formData.append('lampiran', lampiran[0])
      }

      let url = api.suratKeluar
      if (data.id) {
        formData.append('_method', 'PUT')
        url = api.suratKeluar + '/' + data.id
      }
      const response = await fetch.post(url, formData)
      resolve(response)
    } catch (error) {
      reject(error)
    }
  })
}

export const disposisiSurat = async data =>
  await fetch.post(api.disposisi, data)

export const headerSuratKeluar = [
  { sortable: false, text: 'No. Urut', value: 'index_surat', align: 'right' },
  {
    text: 'TGL. SURAT',
    sortable: false,
    value: 'tgl_surat',
    align: 'center'
  },
  {
    text: 'NOMOR SURAT',
    sortable: false,
    value: 'index_surat_tu',
    width: 200
  },
  { text: 'KODE', value: 'kode', sortable: false },
  { text: 'INDEX', value: 'klasifikasi.jenis', sortable: false, width: 150 },
  {
    text: 'PENGOLAH',
    sortable: false,
    value: 'nama_bidang',
    width: 300
  },
  { text: 'TUJUAN', sortable: false, value: 'tujuan' },
  { text: 'PERIHAL', sortable: false, value: 'perihal', width: 150 },
  { text: 'RINGKASAN', sortable: false, value: 'ringkasan', width: 150 },
  { text: 'ARSIP', sortable: false, value: 'lampiran' },
  {
    text: 'AKSI',
    sortable: false,
    value: 'actions',
    align: 'center'
  }
]

export const fetchSuratKeluar = async (
  params = {
    page: 1,
    q: '',
    month: null,
    year: null,
    per_page: 10,
    sort: 'dest'
  }
) => {
  try {
    const response = await fetch.get(api.suratKeluar, { params })
    let { data, ...pagination } = response.data
    return Promise.resolve({ data, pagination })
  } catch (error) {
    return Promise.reject(error)
  }
}

export const listJenisSurat = async () => await fetch.get(api.jenisSurat)

export const getListJenisSurat = function() {
  return new Promise((resolve, reject) => {
    fetch
      .get(api.jenisSurat)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getReportSuratMasuk = async (params = {}) => {
  return await download(
    api.reportSuratMasuk,
    params,
    `Laporan Surat Masuk ${params.from} s.d. ${params.to}`
  )
}

export const downloadKartuDisposisi = async id => {
  return await download(api.disposisi + '/' + id, {}, `Kartu Disposisi`)
}

export const getReportSuratKeluar = async (params = {}) => {
  return await download(
    api.reportSuratKeluar,
    params,
    `Laporan Surat Keluar ${params.from} s.d. ${params.to}`
  )
}

export const getListKodeSurat = async (params = {}) =>
  await fetch.get(api.klasifikasiSurat, { params })

export const saveKlasifikasiSurat = async (data = {}) =>
  await fetch.post(api.klasifikasiSurat, data)

export const updateKlasifikasiSurat = async (id = '', data = {}) =>
  await fetch.put(api.klasifikasiSurat + '/' + id, data)

export const deleteKlasifikasiSurat = async id =>
  await fetch.delete(api.klasifikasiSurat + '/' + id)

export const arsipSuratPimpinan = id =>
  fetch.post(`${api.suratMasuk}/pimpinan/${id}/archive`)

export const restoreSuratPimpinan = id =>
  fetch.post(`${api.suratMasuk}/pimpinan/${id}/restore`)

export const approveSuratPimpinan = (id, data = {}) =>
  fetch.post(api.suratMasuk + '/pimpinan/' + id, data)
